import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../../components/Form/Button';
import { QuantityInput } from '../../components/Form/QuantityInput';
import { Icon, trash } from '../../components/Icon/Icon';
import { Img } from '../../components/Img/Img';
import { PriceTagSimple } from '../../components/PriceTagSimple/PriceTagSimple';
import { DeliveryTime } from '../../components/product/DeliveryTime';
import { useTranslation } from '../../i18n/i18n';
import { ProductContainer } from '../../state/product';
import { ApiCartItem } from '../../types';
import './SubscriptionListItem.css';

interface SubscriptionListItemProps {
	item: ApiCartItem;
	onDelete: (item: ApiCartItem) => Promise<void>;
	onChange: (item: ApiCartItem, value: number) => Promise<void>;
}

export const SubscriptionListItem = ({ item, onDelete, onChange }: SubscriptionListItemProps): JSX.Element => {
	const t = useTranslation().cart;
	const [loading, setLoading] = useState(false);
	const { getFinalPrice } = ProductContainer.useContainer();

	const {
		quantity,
		tax,
		product: { name, bundleSize, image, perma, id, displayId },
		price: { currentPrice },
	} = item;

	return (
		<subscription-item style={{ opacity: loading ? '0.5' : 1 }}>
			<Img src={image} width={292} height={292} alt={name} />
			<div className="title">
				<Link to={'/' + perma} target="_blank" rel="noopener noreferrer">
					{name}
				</Link>
			</div>
			<QuantityInput
				disabled={loading}
				defaultValue={quantity}
				onBlur={(value) => onChange(item, value)}
				step={bundleSize}
				iconSize={17}
			/>
			<div className="artnr">{displayId}</div>

			<span className="delivery">
				<DeliveryTime deliveryClass={1} textLength={'short-one-line'} />
			</span>

			<Button
				className="clear"
				disabled={loading}
				onClick={async () => {
					setLoading(true);
					await onDelete(item);
				}}
			>
				<Icon shape={trash} size={16} /> {t.remove}
			</Button>
			<div className="item-price">
				<PriceTagSimple
					price={getFinalPrice(id, currentPrice, quantity)}
					// isCampaign={item.price.special ? true : false}
					vatRate={tax * 100}
				></PriceTagSimple>
			</div>
		</subscription-item>
	);
};
